import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Dashboard = () => {
  const { user, isAdmin } = useAuth();

  return (
    <div style={styles.container}>
      <div style={styles.welcome}>
        <h1 style={styles.title}>Welcome, {user?.name || user?.email}! 👋</h1>
        <p style={styles.subtitle}>What would you like to do today?</p>
      </div>

      <div style={styles.cards}>
        <Link to="/recipes" style={styles.card}>
          <div style={styles.cardIcon}>📖</div>
          <h3 style={styles.cardTitle}>Browse Recipes</h3>
          <p style={styles.cardDesc}>View all available recipes</p>
        </Link>

        <Link to="/recipes/new" style={styles.card}>
          <div style={styles.cardIcon}>➕</div>
          <h3 style={styles.cardTitle}>Create Recipe</h3>
          <p style={styles.cardDesc}>Add a new recipe</p>
        </Link>

        <Link to="/tools/converter" style={{...styles.card, ...styles.toolCard}}>
          <div style={styles.cardIcon}>🔄</div>
          <h3 style={styles.cardTitle}>Unit Converter</h3>
          <p style={styles.cardDesc}>Convert weights, volumes & temps</p>
        </Link>

        {isAdmin && (
          <Link to="/admin/users" style={{...styles.card, ...styles.adminCard}}>
            <div style={styles.cardIcon}>👑</div>
            <h3 style={styles.cardTitle}>Manage Users</h3>
            <p style={styles.cardDesc}>Admin user management</p>
          </Link>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '1000px',
    margin: '0 auto',
    padding: '2rem'
  },
  welcome: {
    textAlign: 'center',
    marginBottom: '2rem'
  },
  title: {
    fontSize: '2rem',
    color: '#1e3a5f',
    margin: '0 0 0.5rem 0'
  },
  subtitle: {
    color: '#6b7280',
    fontSize: '1.1rem',
    margin: 0
  },
  cards: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '1.5rem'
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '2rem',
    textDecoration: 'none',
    textAlign: 'center',
    boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
    transition: 'transform 0.2s, box-shadow 0.2s',
    border: '2px solid transparent'
  },
  adminCard: {
    borderColor: '#7c3aed',
    backgroundColor: '#faf5ff'
  },
  toolCard: {
    borderColor: '#2563eb',
    backgroundColor: '#eff6ff'
  },
  cardIcon: {
    fontSize: '3rem',
    marginBottom: '1rem'
  },
  cardTitle: {
    fontSize: '1.2rem',
    color: '#1e3a5f',
    margin: '0 0 0.5rem 0'
  },
  cardDesc: {
    color: '#6b7280',
    margin: 0,
    fontSize: '0.9rem'
  }
};

export default Dashboard;
